'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "hours" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/hours.js
// module id = 403
// module chunks = 0